import { useQueryClient } from 'react-query';
import { useSelector } from 'react-redux';

/**
 * Does this company get the NEW schedule page at /schedule/themes? ALL of:
 *   - company.nav_v6 === true        (the new navigation is on for the company; the dev-only localStorage override does NOT count)
 *   - the account is not a restaurant (restaurant accounts never see it)
 *   - the backend says the fleet is ready (`schedule_v2.ready`) or the company already crossed that line once
 *     (`schedule_v2.enabled` / `company.schedule_v2_enabled_at`, sticky on the server)
 * Anything else renders the old page exactly as before.
 */
export function scheduleV6Open(details) {
  if (!details || typeof details !== 'object') return false;
  const c = details.company;
  if (!c || c.account_type === 'restaurant') return false;
  if (c.nav_v6 !== true) return false;
  const s = details.schedule_v2;
  return !!((s && (s.enabled === true || s.ready === true)) || c.schedule_v2_enabled_at);
}

/** Same source order as useNavV6 / useEntitlements: the router's cached details first, then redux. */
export function useCompanyDetails() {
  const redux = useSelector((s) => s.global?.companyDetails);
  let cached;
  try {
    // eslint-disable-next-line react-hooks/rules-of-hooks -- always called; the try only tolerates a missing provider
    cached = useQueryClient().getQueryData('getUserSubscription');
  } catch (_) { cached = undefined; }
  return cached ?? redux ?? null;
}

export function useScheduleV6Gate() {
  return scheduleV6Open(useCompanyDetails());
}

export default useScheduleV6Gate;
